import {
  BUILDING_DROPDOWN_URL,
  BUILDING_SINGLE_DETAIL,
  CREATE_BUILDING,
  DELETE_BUILDING,
  LIST_BUILDING,
} from "../api";
import axiosInstance from "../axiosInstance";

export const createBuilding = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_BUILDING, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((error) => {
        onResponse(error?.response?.data);
      });
  } catch (error) {}
};

export const listBuildingAction = (props) => (onResponse) => {
  try {
    let BASE_URL = LIST_BUILDING + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props?.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props?.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props?.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props?.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props?.is_draft) {
      BASE_URL += "is_draft=" + props.is_draft + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const getSingleBuildingDetail = (props) => (onResponse) => {
  try {
    let BASE_URL = BUILDING_SINGLE_DETAIL + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.id) {
      BASE_URL += "id=" + props.id + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const deleteBuildingHandler = (props) => (onResponse) => {
  console.log(props);

  try {
    axiosInstance
      .delete(DELETE_BUILDING, { data: { id: props.id } })
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const listBuildingDropdown = (props) => (onResponse) => {
  try {
    let BASE_URL = BUILDING_DROPDOWN_URL + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.museum_id) {
      BASE_URL += "museum_id=" + props.museum_id + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props.is_template) {
      BASE_URL += "is_template=" + props.is_template + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};

export const uploadBulkLocationHandler = (props) => (onResponse) => {
  try {
    axiosInstance
      .post("/location/building/bulk-create", props?.values)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) {}
};
